import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
  constructor() {}

  sessionData(): string {
    return localStorage.getItem('sessionToken') || '';
  }

  setSessionData(token: string): void {
    localStorage.setItem('sessionToken', token);
  }

  deleteSessionData() {
    localStorage.removeItem('sessionToken');
  }

  CompanyLogo() {
    return localStorage.getItem('companyLogoPath');
  }

  setCompanyLogo(path: string): void {
    localStorage.setItem('companyLogoPath', path);
  }

  setBranchData(id: string): void {
    localStorage.setItem('branchData', id);
  }

  branchData(): string | null {
    return localStorage.getItem('branchData');
  }

  setConsoleIds(hash: Record<string, any>): void {
    localStorage.setItem('consoleIds', JSON.stringify(hash));
  }

  getConsoleIds(): Record<string, any> | null {
    const consoleIds = localStorage.getItem('consoleIds');
    return consoleIds ? JSON.parse(consoleIds) : null;
  }

  clearData(): void {
    localStorage.clear();
  }
}
